import { FC } from 'react'
import { Whitepaper } from '@/api/types'
import Image from '@/components/Image'

type Props = Whitepaper

const Component: FC<Props> = ({ title, eyeCatching, body, }) => {
  const size = 'w=542&h=335'

  return (
    <>
      <div className="mb-5 md:w-full md:text-left">
        <h2 className="text-2xl md:text-3xl font-semibold text-primary-900">{title}</h2>
      </div>

      <div className="my-4 rounded-[4px] aspect-video w-full">
        <Image url={eyeCatching.url} size={size} />
      </div>

      <div className="w-full leading-7 tracking-[0.01em] whitespace-pre-line">
        <p>{body}</p>
      </div>
    </>
  )
}

export default Component
